/**
 * api接口统一管理
 */
import {get, post} from './axios';
import axios from "axios";

/**
 *
 * @param {string} params
 * 我们定义了一个topics方法
 * 这个方法有一个参数params
 * params是我们请求接口时携带的参数对象
 * 而后调用了我们封装的post方法
 * post方法的第一个参数是我们的接口地址
 * 第二个参数是topics的params参数
 * 即请求接口时携带的参数对象
 * 最后通过export导出topics。
 */
//图片主机地址
export const IMG_URL = axios.defaults.baseURL + '/img';

const INFORMATION_URl = localStorage.getItem('x-token') ? '/information-app' : '/open/information-app'
const OPEN_URl = localStorage.getItem('x-token') ? '' : '/open'
const CENTERPROFILEAPP_URl = '/open/center-profile-app'
const GRADECONTROLAPP_URl = '/open/grade-control'

// 轮播图
export const getBannerList = params => get(`/open/banner/${params.location}/${params.client}/top/5`, params)

// 分页查询新闻资讯、质控课程、质控公告
export const getPageList = params => get(INFORMATION_URl + `/page/${params.number}/${params.limit}`, params)

// 列表查询资讯类型
export const getInformationType = params => get(OPEN_URl + `/information-type-app`, params)

// 按 id 查询新闻资讯、质控课程、质控公告
export const getPageDetails = params => get(INFORMATION_URl + `/${params.id}`, params)

// 分页查询中心简介
export const getCenterBriefIntroduction = params => get(CENTERPROFILEAPP_URl + `/page/${params.number}/${params.limit}`, params)

// 分页查询分级质控
export const getQualityControl = params => get(GRADECONTROLAPP_URl + `/page/${params.number}/${params.limit}`, params)

// 分页查询直播管理
export const getLiveManagement = params => get(`/live-management/page/${params.number}/${params.limit}`, params)

// 按 id 查询分级质控
export const getQualityControlDetails = params => get(GRADECONTROLAPP_URl + `/${params.id}`, params)

// 分页查询资讯评论
export const getInformationComment = params => get(`/information-comment-app/page/${params.number}/${params.limit}`, params)

// 新增资讯评论
export const addInformationComment = params => post(`/information-comment-app`, params)

// 资讯点赞&取消点赞
export const informationPraise = params => post(`/information-like-app/toggle/${params.informationId}`, params)

// 资讯收藏&取消收藏
export const informationCollect = params => post(`/information-collect-app/toggle/${params.informationId}`, params)

// 资讯 分享
export const informationShare = params => post(`/information-share-app/share/${params.informationId}`, params)

// 分页查询我的点赞
export const getInformationPraiseList = params => get(`/information-like-app/page/${params.number}/${params.limit}`, params)

// 分页查询我的资讯 分享
export const getInformationShareList = params => get(`/information-share-app/page/${params.number}/${params.limit}`, params)

// 分页查询新闻资讯、质控课程、质控公告
export const getSearchList = params => get(`/information-app/page/${params.number}/${params.limit}`, params)

// 新增哨点医院招募信息
export const addSentinelHospital = params => post(`/sentinel-hospital`, params)

// 新增联络员招募
export const addLiaisonRecruitment = params => post(`/liaison-recruitment-app`, params)

// 联络招募员问题列表
export const getSentinelHospital = params => get(`/questionnaire/liaisonRecruitment/list`, params)

// 哨点医院问题列表
export const getLiaisonRecruitment = params => get(`/questionnaire/sentinelHospital/list`, params)

// 医疗安全不良事件专项行动问题列表
export const getMedicalSafety = params => get(`/questionnaire/medicalSafety/list`, params)

// 新增医疗安全不良事件专项行动
export const addMedicalSafety = params => post(`/medical-safety-action`, params)

// 省市列表树
export const getCityListTree = params => get(`/open/city/list-tree`, params)

// 预约问题列表
export const getAgreementProblemList = params => get(`/questionnaire/list`, params)

// 新增质控会议记录
export const addAgreement = params => post(`/conference-information`, params)

// 按 id 查询直播管理
export const getLiveDetail = params => get(`/live-management/${params.id}`, params)

// 列表查询质控会议记录
export const getConferenceInformation = params => get(`/conference-information/live`, params)

// 新增意见反馈
export const addFeedback = params => post(`/user-feedback`, params)

// 多级分类课程
export const getPageListTwo = params => get(`/information-app/category-page/${params.number}/${params.limit}`, params)

// 获取华为云OBS临时密钥
export const getOBS = params => get(`/upload/obs/temporary-credentials`, params)


// WEBPACK FOOTER //
// ./src/api/home.js